<main class="check">
  <header [attr.id]="data.title">
    <h3 [class.error]="!data.isPassed">{{ data.title }}</h3>
  </header>

  <section
    class="check-cases"
    [class.border]="data.main.isApplicable"
    [attr.id]="data.main.title"
  >
    <mat-slide-toggle
      [color]="data.main.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.main.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="data.main.isApplicable && !data.main.isPassed"
        >{{ data.main.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="data.main.isApplicable && !data.main.isPassed"
      *ngIf="readonly || printPreview"
      >{{ data.main.title }}
    </span>

    <div class="cases" *ngIf="data.main.isApplicable; else notApplicable">
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.certificateNumber"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.fireExtinguishingSystemTypes"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.waterSupplyDescription"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.waterSupplySource.isApplicable"
    [attr.id]="data.waterSupplySource.title"
  >
    <mat-slide-toggle
      [color]="data.waterSupplySource.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.waterSupplySource.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.waterSupplySource.isApplicable &&
          !data.waterSupplySource.isPassed
        "
        >{{ data.waterSupplySource.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.waterSupplySource.isApplicable && !data.waterSupplySource.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.waterSupplySource.title }}
    </span>
    <div
      class="cases"
      *ngIf="data.waterSupplySource.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.waterSupplySource.measuringStationAccordingSpec"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.waterSupplySource.waterStatsBeforeStationAccordingSpec
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.waterSupplySource.waterStatsBeforeSprayerHeadAccordingSpec
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.waterSupplySource.shutdownPumpType"
      ></authority-labs-check-case>
      <!-- <authority-labs-check-water-characteristics-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview" [readonly]="readonly"
        [inspection]="data.waterSupplySource.shutdownPumpDetails"
        [characteristics]="plumberRoomWaterSupplyCharacteristics"
      ></authority-labs-check-water-characteristics-case> -->
      <authority-labs-check-shutdown-pump-details-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [shutdownPumpDetails]="data.waterSupplySource.shutdownPumpDetails"
      >
      </authority-labs-check-shutdown-pump-details-case>
      <authority-labs-check-water-characteristics-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.waterSupplySource.reservoirVolume"
        [characteristics]="poolingVolumeCharacteristics"
      ></authority-labs-check-water-characteristics-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.waterSupplySource.backedupByMunicipalWaterNetwork"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.waterSupplySource.fireExtinguishersWaterSupplySource"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.fireExtinguishingSystems.isApplicable"
    [attr.id]="data.fireExtinguishingSystems.title"
  >
    <mat-slide-toggle
      [color]="data.fireExtinguishingSystems.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.fireExtinguishingSystems.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.fireExtinguishingSystems.isApplicable &&
          !data.fireExtinguishingSystems.isPassed
        "
      >
        {{ data.fireExtinguishingSystems.title }}
      </span>
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.fireExtinguishingSystems.isApplicable &&
        !data.fireExtinguishingSystems.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.fireExtinguishingSystems.title }}
    </span>
    <div
      class="cases"
      *ngIf="data.fireExtinguishingSystems.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.fireExtinguishingSystems.equipmentAccordingSpec"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.fireExtinguishingSystems.equipmentMeetPlans"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.fireExtinguishingSystems.distancesBetweenSprayersAccordingSpec
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.fireExtinguishingSystems.sprinklersInstalledAsNeeded"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.fireExtinguishingSystems.sprinklersInterruptionExist"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.fireExtinguishingSystems.sprnklersOnDrySystemsAccordingSpec
        "
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.pressureSystem.isApplicable"
    [attr.id]="data.pressureSystem.title"
  >
    <mat-slide-toggle
      [color]="data.pressureSystem.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.pressureSystem.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.pressureSystem.isApplicable && !data.pressureSystem.isPassed
        "
        >{{ data.pressureSystem.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.pressureSystem.isApplicable && !data.pressureSystem.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.pressureSystem.title }}
    </span>
    <div
      class="cases"
      *ngIf="data.pressureSystem.isApplicable; else notApplicable"
    >
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.pressureSystem.location"
        label="מיקום ההסנקה"
      ></authority-labs-check-value-case>
    </div>
  </section>

  <section
    class="check-cases"
    [class.border]="data.valvesPlumbingFittings.isApplicable"
    [attr.id]="data.valvesPlumbingFittings.title"
  >
    <mat-slide-toggle
      [color]="data.valvesPlumbingFittings.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.valvesPlumbingFittings.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.valvesPlumbingFittings.isApplicable &&
          !data.valvesPlumbingFittings.isPassed
        "
        >{{ data.valvesPlumbingFittings.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.valvesPlumbingFittings.isApplicable &&
        !data.valvesPlumbingFittings.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.valvesPlumbingFittings.title }}
    </span>
    <div
      class="cases"
      *ngIf="data.valvesPlumbingFittings.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.valvesPlumbingFittings.sprinklerPipingAccordingSpec"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.valvesPlumbingFittings.controlStationsAccordingSpec"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.valvesPlumbingFittings.installationAccordingSpec"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.valvesPlumbingFittings.isControlBodyAccessible"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.valvesPlumbingFittings.valvesWiredToWarningHub"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.valvesPlumbingFittings.pressureDischargersAsRequired"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.valvesPlumbingFittings.pressureWatchesAsRequired"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.preactionSystemsInstallation.isApplicable"
    [attr.id]="data.preactionSystemsInstallation.title"
  >
    <mat-slide-toggle
      [color]="data.preactionSystemsInstallation.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.preactionSystemsInstallation.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.preactionSystemsInstallation.isApplicable &&
          !data.preactionSystemsInstallation.isPassed
        "
        >{{ data.preactionSystemsInstallation.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.preactionSystemsInstallation.isApplicable &&
        !data.preactionSystemsInstallation.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.preactionSystemsInstallation.title }}
    </span>
    <div
      class="cases"
      *ngIf="data.preactionSystemsInstallation.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.preactionSystemsInstallation.preactionSystemType"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.preactionSystemsInstallation.manufacturerNameAndModel
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.preactionSystemsInstallation.systemOperationDescription
        "
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.drySystems.isApplicable"
    [attr.id]="data.drySystems.title"
  >
    <mat-slide-toggle
      [color]="data.drySystems.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.drySystems.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.drySystems.isApplicable && !data.drySystems.isPassed
        "
        >{{ data.drySystems.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="data.drySystems.isApplicable && !data.drySystems.isPassed"
      *ngIf="readonly || printPreview"
      >{{ data.drySystems.title }}
    </span>
    <div class="cases" *ngIf="data.drySystems.isApplicable; else notApplicable">
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.drySystems.manufacturerNameAndModel"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.floodingCoolingExtinguishingSystems.isApplicable"
    [attr.id]="data.floodingCoolingExtinguishingSystems.title"
  >
    <mat-slide-toggle
      [color]="
        data.floodingCoolingExtinguishingSystems.isPassed ? 'primary' : 'warn'
      "
      [(ngModel)]="data.floodingCoolingExtinguishingSystems.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.floodingCoolingExtinguishingSystems.isApplicable &&
          !data.floodingCoolingExtinguishingSystems.isPassed
        "
        >{{ data.floodingCoolingExtinguishingSystems.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.floodingCoolingExtinguishingSystems.isApplicable &&
        !data.floodingCoolingExtinguishingSystems.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.floodingCoolingExtinguishingSystems.title }}
    </span>
    <div
      class="cases"
      *ngIf="
        data.floodingCoolingExtinguishingSystems.isApplicable;
        else notApplicable
      "
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.floodingCoolingExtinguishingSystems.manufacturerNameAndModel
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.floodingCoolingExtinguishingSystems.systemOperationDescription
        "
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.racksAndReinforcement.isApplicable"
    [attr.id]="data.racksAndReinforcement.title"
  >
    <mat-slide-toggle
      [color]="data.racksAndReinforcement.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.racksAndReinforcement.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.racksAndReinforcement.isApplicable &&
          !data.racksAndReinforcement.isPassed
        "
        >{{ data.racksAndReinforcement.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.racksAndReinforcement.isApplicable &&
        !data.racksAndReinforcement.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.racksAndReinforcement.title }}
    </span>
    <div
      class="cases"
      *ngIf="data.racksAndReinforcement.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.racksAndReinforcement.racksFixed"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.racksAndReinforcement.distancesBetweenRacksAccordingSpec
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.racksAndReinforcement.distanceBetweenLastRackAndpipeAccordingSpec
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.racksAndReinforcement.raiserReinforcementsAccordingSpec
        "
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.earthquakeReinforcements.isApplicable"
    [attr.id]="data.earthquakeReinforcements.title"
  >
    <mat-slide-toggle
      [color]="data.earthquakeReinforcements.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.earthquakeReinforcements.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.earthquakeReinforcements.isApplicable &&
          !data.earthquakeReinforcements.isPassed
        "
        >{{ data.earthquakeReinforcements.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.earthquakeReinforcements.isApplicable &&
        !data.earthquakeReinforcements.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.earthquakeReinforcements.title }}
    </span>
    <div
      class="cases"
      *ngIf="data.earthquakeReinforcements.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.earthquakeReinforcements.pipelineIntervalsAccordingSpec
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.earthquakeReinforcements.flexibleCouplingsAccordingSpec
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.earthquakeReinforcements.earthquakeBracesAccordingSpec
        "
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.alarmCheck.isApplicable"
    [attr.id]="data.alarmCheck.title"
  >
    <mat-slide-toggle
      [color]="data.alarmCheck.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.alarmCheck.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.alarmCheck.isApplicable && !data.alarmCheck.isPassed
        "
        >{{ data.alarmCheck.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="data.alarmCheck.isApplicable && !data.alarmCheck.isPassed"
      *ngIf="readonly || printPreview"
      >{{ data.alarmCheck.title }}
    </span>
    <div class="cases" *ngIf="data.alarmCheck.isApplicable; else notApplicable">
      <authority-labs-check-alarms-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [alarmCheck]="data.alarmCheck"
      ></authority-labs-check-alarms-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.foamCenterInstallation.isApplicable"
    [attr.id]="data.foamCenterInstallation.title"
  >
    <mat-slide-toggle
      [color]="data.foamCenterInstallation.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.foamCenterInstallation.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.foamCenterInstallation.isApplicable &&
          !data.foamCenterInstallation.isPassed
        "
        >{{ data.foamCenterInstallation.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.foamCenterInstallation.isApplicable &&
        !data.foamCenterInstallation.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.foamCenterInstallation.title }}
    </span>
    <div
      class="cases"
      *ngIf="data.foamCenterInstallation.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamCenterInstallation.equipmentInstalledAsDesigned"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamCenterInstallation.dosageUnitType"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.foamCenterInstallation.concentrationTankVolumeAsDesigned
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamCenterInstallation.concentrationDetails"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamCenterInstallation.installationAccordingPlans"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamCenterInstallation.concentratePipingAsRequired"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamCenterInstallation.solutionPipeGalvanized"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamCenterInstallation.foamCenterAtShadedArea"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.foamFloodingSystems.isApplicable"
    [attr.id]="data.foamFloodingSystems.title"
  >
    <mat-slide-toggle
      [color]="data.foamFloodingSystems.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.foamFloodingSystems.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.foamFloodingSystems.isApplicable &&
          !data.foamFloodingSystems.isPassed
        "
        >{{ data.foamFloodingSystems.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.foamFloodingSystems.isApplicable &&
        !data.foamFloodingSystems.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.foamFloodingSystems.title }}
    </span>
    <div
      class="cases"
      *ngIf="data.foamFloodingSystems.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamFloodingSystems.pressureReducersAsDesigned"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamFloodingSystems.systemActivation"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamFloodingSystems.uniformFlow"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamFloodingSystems.reducerPressureAsDesigned"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamFloodingSystems.dispensingDevicesWorks"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamFloodingSystems.FoamSampling"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamFloodingSystems.waterCheck"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.foamFloodingSystems.concentrateFoamfromStorageVessels
        "
      ></authority-labs-check-case>
      <authority-labs-check-percentage-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.foamFloodingSystems.foamConcentrationResults"
      ></authority-labs-check-percentage-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.closedFoamSpraySystems.isApplicable"
    [attr.id]="data.closedFoamSpraySystems.title"
  >
    <mat-slide-toggle
      [color]="data.closedFoamSpraySystems.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.closedFoamSpraySystems.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.closedFoamSpraySystems.isApplicable &&
          !data.closedFoamSpraySystems.isPassed
        "
        >{{ data.closedFoamSpraySystems.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.closedFoamSpraySystems.isApplicable &&
        !data.closedFoamSpraySystems.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.closedFoamSpraySystems.title }}
    </span>
    <div
      class="cases"
      *ngIf="data.closedFoamSpraySystems.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.closedFoamSpraySystems.venturiFlowMeterInstallation"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.closedFoamSpraySystems.flowRateAsDesigned"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.closedFoamSpraySystems.foamSampling"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.closedFoamSpraySystems.waterCheck"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.closedFoamSpraySystems.concentrateFoamfromStorageVessels
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.closedFoamSpraySystems.foamConcentrationResults"
      ></authority-labs-check-case>
    </div>
  </section>
</main>

<ng-template #notApplicable>
  <mat-radio-group disabled="true" class="print-preview" *ngIf="printPreview">
    <mat-radio-button checked="false">מתאים</mat-radio-button>
    <mat-radio-button checked="false">לא מתאים</mat-radio-button>
    <mat-radio-button value="true" checked="true">לא ישים</mat-radio-button>
  </mat-radio-group>
</ng-template>
